/**
 * Product Type Constants
 * Ürün tipleri ve ilgili sabit değerler
 */

export class ProductTypeConstants {
  // Product type names
  static readonly TOUR = 'tour';
  static readonly YACHT = 'yacht';
  
  // Default product type (fallback)
  static readonly DEFAULT = this.TOUR;
  
  /**
   * Geçerli product type kontrolü
   * @param type Kontrol edilecek type
   * @returns Geçerli mi?
   */
  static isValid(type: string): boolean {
    return type === this.TOUR || type === this.YACHT;
  }
  
  /**
   * Product type'ı normalize et (geçersizse default döndür)
   * @param type Normalize edilecek type
   * @returns Normalize edilmiş type
   */
  static normalize(type: string | undefined | null): string {
    if (!type || !this.isValid(type)) {
      return this.DEFAULT;
    }
    return type;
  }
}

